import { callBackendApi } from "../../service/axios";

export const getPOHs = () => {
  return callBackendApi("get", "/bff/poh");
};
export const getOffices = () => {
  return callBackendApi("get", "/bff/offices");
};

export const getJobProfiles = () => {
  return callBackendApi("get", "/bff/job-profiles");
};

export const getDepartments = () => {
  return callBackendApi("get", "/bff/departments");
};

export const getMiscellaneous = () => {
  return callBackendApi("get", "/bff/miscellaneous");
};
